import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../../Common/Layout/components/Navbar/navbar.component';
import { ResearchRequestDialogComponent } from '../../../../Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';

export const burrellesSupportNav: NavItem[] = [
    {
        label: 'Core.navigation.support.supportAndTraining',
        icon: 'fa-duotone fa-regular fa-headset',
        id: 'primaryNavSupport',
        collapsed: false,
        items: [
            {
                label: 'Core.navigation.support.submitRequest',
                type: NavItemType.dialog,
                permissions: [
                    userPermissionsEnum.targeting,
                    userPermissionsEnum.advancedTargeting
                ],
                dialogReference: ResearchRequestDialogComponent,
                id: 'primaryNavSubmitResearchRequest',
            },
            {
                label: 'Core.navigation.support.email',
                id: 'primaryNavSupportEmail',
                url: 'mailto:inquiry@burrelles.com'
            },
            {
                label: 'Core.navigation.burrelles.phoneNumber',
                id: 'primaryNavSupportHelpPhoneNumber',
                url: 'Tel: (800) 631-1160'
            }
        ]
    }
];
